import React from 'react';
import { CirclePlus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function CreatePostButton() {
  const navigate = useNavigate();

  return (
    <CirclePlus
      color="var(--global-main)"
      style={{
        position: 'absolute',
        background: 'var(--global-main-lighter-8)',
        borderRadius: '50%',
        bottom: '1rem',
        right: '1rem',
        width: '3rem',
        height: '3rem',
        cursor: 'pointer',
      }}
      onClick={() => {
        navigate('/create-post');
      }}
    />
  );
}
